import { AxiosError } from "axios";
import { showNotification } from "../../common/actionCreators/dispatchNotification";
import apiClient from "../../common/api/apiClient";
import { ApiError } from "../../common/api/apiResponse";
import { GroupVisitDto, GroupVisitResetPasswordDto, ImageDto } from "./groupVisits.dtos";

const groupVisitsUrl = '/groupVisits/';
const changePasswordUrl = '/account/changeGroupVisitPassword';
const resetPasswordUrl = "/account/resetGroupVisitPassword";

export const getGroupVisitsApi = async () => {
    return await apiClient.get(groupVisitsUrl)
    .then((res) => {
        return res.data.result;
    })
    .catch((err) => {
        if (err && err.response) {
          const axiosError = err as AxiosError<ApiError>;
          if (axiosError.response) {
            showNotification(axiosError.response?.data?.error?.message, 'error');
          }
        }
        else {
          showNotification('An error occurred while retrieving group visits.', 'error');
        }
        throw err;
    });
};

export const getGroupVisitApi = async (request: string) => {
    return await apiClient.get(groupVisitsUrl + request)
    .then((res) => {
        return res.data.result;
    })
    .catch((err) => {
        if (err && err.response) {
          const axiosError = err as AxiosError<ApiError>;
          if (axiosError.response) {
            showNotification(axiosError.response?.data?.error?.message, 'error');
          }
        }
        else {
          showNotification('An error occurred while retrieving group visit.', 'error');
        }
        throw err;
    });
};

export const updateGroupVisitApi = async (request: GroupVisitDto) => {
    return await apiClient.put(groupVisitsUrl, request)
      .then((res) => {
        showNotification("Group visit updated", 'success');
        return res.data.result;
      })
      .catch((err) => {
        if (err && err.response) {
          const axiosError = err as AxiosError<ApiError>;
          if (axiosError.response) {
            showNotification(axiosError.response.data.error.message, 'error');
          }
        }
        else {
          showNotification('An error occurred while updating group visit.', 'error');
        }
        throw err;
      });
};

export const createGroupVisitApi = async (request: GroupVisitDto) => {  
    return await apiClient.post(groupVisitsUrl, request)
      .then((res) => {
        showNotification("Group visit created", 'success');
        return res.data.result;
      })
      .catch((err) => {
        if (err && err.response) {
          const axiosError = err as AxiosError<ApiError>;
          if (axiosError.response) {
            showNotification(axiosError.response.data.error.message, 'error');
          }
        }
        else {
          showNotification('An error occurred while creating group visit.', 'error');
        }
        throw err;
      });
};

export const deleteImageApi = async (image: ImageDto) => {
  return await apiClient.delete(groupVisitsUrl + 'images/' + image.id)
  .then((res) => {
    showNotification("Image or video deleted", 'success');
    return res.data.result;
  })
  .catch((err) => {
    if (err && err.response) {
      const axiosError = err as AxiosError<ApiError>;
      if (axiosError.response) {
        showNotification(axiosError.response.data.error.message, 'error');
      }
    }
    else {
      showNotification('An error occurred while deleting image or video.', 'error');
    }
    throw err;
  });
}

export const getGroupVisitPasswordResetStatusApi = async (request: string) => {
  return await apiClient.get(`${groupVisitsUrl}reset-required/${request}`)
  .then((res) => {
      return res.data;
  })
  .catch((err) => {
      if (err && err.response) {
        const axiosError = err as AxiosError<ApiError>;
        if (axiosError.response) {
          showNotification(axiosError.response?.data?.error?.message, 'error');
        }
      }
      else {
        showNotification('An error occurred while retrieving group visit.', 'error');
      }
      throw err;
  });
};

export const resetPasswordApi = async (request: GroupVisitResetPasswordDto) => {
  return await apiClient
    .post(resetPasswordUrl, request)
    .then(() => {
      showNotification("Your password has been reset.", "success");
      return true;
    })
    .catch(err => {
      showNotification(err.response.data, "error");
    });
};

export const changePasswordApi = async (request: GroupVisitResetPasswordDto) => {
  return await apiClient.post(changePasswordUrl, request)
    .then((res) => {
      showNotification('Your password has been updated.', 'success');
      return true;
    })
    .catch((err) => { showNotification('An error occurred while changing password.', 'error');
    });
};

export const forgotPasswordApi = async (request: string) => {
  return await apiClient
    .get(`/account/${request}/sendGroupVisitPasswordResetEmail`)
    .then(_res => {
      showNotification("Forgot Password email has been sent.", "success");
      return true;
    })
    .catch(err => {
      showNotification(err.response.data, "error");
    });
};